import React from 'react';
import { AlertTriangle, Loader2 } from 'lucide-react';
import SettingsModal from './SettingsModal';

const ConfirmDialog = ({
  open,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  danger = false,
  loading = false,
  onConfirm,
  onCancel,
}) => (
  <SettingsModal
    open={open}
    title={title}
    onClose={loading ? () => {} : onCancel}
    maxWidth="max-w-md"
    footer={
      <div className="flex justify-end gap-3">
        <button
          type="button"
          onClick={onCancel}
          disabled={loading}
          className="rounded-lg border border-gray-300 px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-white disabled:opacity-50"
        >
          {cancelLabel}
        </button>
        <button
          type="button"
          onClick={onConfirm}
          disabled={loading}
          className={`inline-flex items-center gap-2 rounded-lg px-4 py-2 text-sm font-semibold text-white disabled:opacity-50 ${
            danger
              ? 'bg-red-600 hover:bg-red-700'
              : 'bg-blue-600 hover:bg-blue-700'
          }`}
        >
          {loading && <Loader2 className="h-4 w-4 animate-spin" />}
          {confirmLabel}
        </button>
      </div>
    }
  >
    <div className="flex items-start gap-3">
      <div
        className={`rounded-full p-2 ${
          danger ? 'bg-red-50 text-red-600' : 'bg-amber-50 text-amber-600'
        }`}
      >
        <AlertTriangle className="h-5 w-5" />
      </div>
      <p className="pt-1 text-sm leading-6 text-gray-600">{message}</p>
    </div>
  </SettingsModal>
);

export default ConfirmDialog;
